import React, {useEffect, useRef, useState} from "react";
import moment from "moment-timezone";
import ReactTooltip from "react-tooltip";
import {DateRangePicker} from "react-dates";

import { Row } from "../../components/Layout";
import CSVExporter from "components/Table/CSVExporter";
import NTMButton from "../../components/Buttons/NTMButton";
import NTMSelect from "components/Buttons/NTMSelect";
import NTMTable from "../../components/Table/NTMTable";
import InfoCell from "../../components/Layout/InfoCell";

import { useGetDevices, getStatisticalCalculation } from "../../service/Agrismart2Service";
import styles from "./_agrismart.module.scss";

export default function ReviewPageV2() {

	let {devices} = useGetDevices()
	let [device, setDevice] = useState();
	let [interval, setIntvl] = useState("daily");
	let [startDate, setStartDate] = useState();
	let [endDate, setEndDate] = useState();
	let [focusedInput, setFocusedInput] = useState();
	let [data, setData] = useState([])
	let [aggregates, setAggregates] = useState({})
	let buttonRef = useRef();

	useEffect(getData, [device, interval, startDate, endDate]);
	if(devices.length === 0) return <div/>
	if(!device) {
		setDevice(devices[0].device)
	}

	function getData() {
		let start;
		let end = moment();
		if(interval === "daily") {
			start = end.clone();
		} else if(interval === "weekly") {
			start = end.clone().subtract(7, 'days');
		} else if( interval === "monthly") {
			start = end.clone().subtract(1, "months")
		} else if (startDate !== null && endDate !== null) {
			start = moment(startDate);
			end = moment(endDate);
		} else return;
		getStatisticalCalculation(device, start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD")).then(a => {
			let data = []
			let aggregates = {}
			a.forEach(d => {
				switch(d.type) {
					case 2:	// avg
						data.push({ type: 'media', ...d.paramMap });
						break;
					case 3: // min
						data.push({ type: 'min', ...d.paramMap });
						break;
					case 4: // max
						data.push({ type: 'max', ...d.paramMap });
						break;
					case 5: // sum
					case 6: // adv
						aggregates = { ...aggregates, ...d.paramMap }
						break;
					default:
						break;
				}
			})
			setData(data)
			setAggregates(aggregates)
		})
	}

	function toCSV(data, parameters) {
		return data.map(d => {
			let datum = {
				"valori": d.type,
			}
			// rietichetta i dati secodo le label dei parametri (va su intestazione file csv)
			parameters.forEach(p => {
				if (p.labelLong != null && p.name != null)
					datum[p.labelLong] = d[p.name]
			});
			return datum;
		})
	}

	function getValue(field) {
		return field || field === 0 ? `${+field.toFixed(2)}` : "-"
	}

	let deviceObj = devices.find(d => d.device === device);
	let parameters = deviceObj?.configuration?.parameters ?? []
	parameters.sort((a, b) => a.name.localeCompare(b.name))

	const header = [
		{
			Header: "Valori",
			accessor: 'type',
			Cell: props => <div style={{color:"#AB2430", textTransform:"uppercase", fontWeight:"bold"}}>{props.original.type}</div>
		},
		...parameters.map(p => ({
			Header: p.labelShort,
			accessor: p.name,
			Cell: props => <div>{`${getValue(props.original[p.name])} ${p.unit}`}</div>
		}))
	]

	return <div className="animated fadeIn">
		<Row className={styles.box}>
			<NTMSelect value={device} onChange={event => setDevice(event.target.value)}>
				{devices.map(d =>
					<option key={d.device} value={d.device}>{d.label || d.device}</option>
				)
				}
			</NTMSelect>
			<NTMButton
				primary={interval === "daily"}
				unselected={interval !== "daily" ? 'true' : undefined}
				onClick={() => setIntvl("daily")}
			>Oggi</NTMButton>
			<NTMButton
				primary={interval === "weekly"}
				unselected={interval !== "weekly" ? 'true' : undefined}
				onClick={() => setIntvl("weekly")}
			>Ultimi 7 gg</NTMButton>
			<NTMButton
				primary={interval === "monthly"}
				unselected={interval !== "monthly" ? 'true' : undefined}
				onClick={() => setIntvl("monthly")}
			>Ultimi 30 gg</NTMButton>

			<div data-tip data-for='global' data-event='click' ref={buttonRef}>
				<NTMButton
					primary={interval === "custom"}
					unselected={interval !== "custom" ? 'true' : undefined}
				>
					{
						startDate ?
							`${moment(startDate).format("DD/MM/YYYY")}
											-
							${moment(endDate).format("DD/MM/YYYY")}`
							: <>Scegli Periodo&nbsp;<i className="fa fa-caret-down"
							                           aria-hidden="true"/></>
					}
				</NTMButton>
			</div>
			<ReactTooltip
				id='global'
				aria-haspopup='true'
				effect='solid'
				place={"bottom"}
				clickable
				getContent={() => <DateRangePicker
					startDate={startDate} // momentPropTypes.momentObj or null,
					startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
					endDate={endDate} // momentPropTypes.momentObj or null,
					endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
					onDatesChange={({startDate, endDate}) => {
						setIntvl("custom")
						setStartDate(startDate)
						setEndDate(endDate)
						if (startDate !== null && endDate !== null) {
							buttonRef.current.click();
						}
					}} // PropTypes.func.isRequired,
					focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
					onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
					withPortal={true}

					startDatePlaceholderText={"Inizio"}
					endDatePlaceholderText={"Fine"}
					displayFormat={"DD/MM/YYYY"}
					isOutsideRange={(o) => o.isAfter(moment(), 'day')}
					small={true}
				/>}
			/>
		</Row>
		<div style={{ margin: "1rem auto"}}>
			<CSVExporter title={"Scarica"} name={"Agrismart"} data={toCSV(data, parameters)}/>
			<NTMTable
				header={header}
				body={data}
				defaultPageSize={3}
				showPagination={false}
			/>
		</div>
		<div>
			<InfoCell name={"millimetri di pioggia"} value={getValue(aggregates["rainfall#1"])} um={" mm"}/>
			<InfoCell name={"ore di freddo"} value={getValue(aggregates["coldHours#1"])} um={" ore"}/>
			<InfoCell name={"ore di caldo"} value={getValue(aggregates["hotHours#1"])} um={" ore"}/>
			<InfoCell name={"ore di bagnatura"} value={getValue(aggregates["wetHours#1"])} um={" ore"}/>
			<InfoCell name={"ore di luce"} value={getValue(aggregates["lightHours#1"])} um={" ore"}/>
			<InfoCell name={"gradi ora"} value={getValue(aggregates["temperatureHours#1"])} um={" °ora"}/>
		</div>
	</div>
}
